import styled from 'styled-components';

const NavigationBuildingHeroStyle = styled.div`
	--padTB: var(--sp2x);
	--padLR: var(--sp4x);
	--gapDistance: var(--sp2x);
	--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
	--distanceBottomM: var(--sp9x);

	margin-left: var(--contPaddingLR);
	margin-right: var(--contPaddingLR);
	margin-bottom: var(--distanceBottomM);

	display: grid;
	grid-template-columns: repeat(3, 1fr);
	width: fit-content;
	gap: var(--gapDistance);

	.building-navigation-wrapper-item {
		padding: var(--padTB) var(--padLR);
		border-radius: var(--radiusBorder);
		background-color: var(--white);
		transition: all var(--trTime) ease-out;

		&.active {
			background-color: var(--black1000);
			color: var(--white);
		}

		&.disable {
			background-color: var(--disable);
			color: var(--black500);
		}
	}

	@media (hover: hover) {
		&:hover {
			.building-navigation-wrapper-item {
				&.hovered {
					&:hover {
						cursor: pointer;
						color: var(--white);
						background-color: var(--black1000);
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp4x);
		--gapDistance: var(--sp2x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp9x);
	}
	/* //! 1510 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp4x);
		--gapDistance: var(--sp2x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp7x);
	}
	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp4x);
		--gapDistance: var(--sp2x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp4x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--padTB: var(--sp1-5x);
		--padLR: var(--sp3x);
		--gapDistance: var(--sp1x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp4x);
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--padTB: var(--sp1-5x);
		--padLR: var(--sp3x);
		--gapDistance: var(--sp1x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp5x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--padTB: var(--sp1-5x);
		--padLR: var(--sp3x);
		--gapDistance: var(--sp1x);
		--radiusBorder: calc(var(--sp1-5x) - var(--sp0-5x) / 2);
		--distanceBottomM: var(--sp5x);
	}
	/* //! 414 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--padTB: var(--sp1-5x);
		--padLR: var(--sp2-5x);
		--gapDistance: var(--sp1x);
		--radiusBorder: var(--sp1x);
		--distanceBottomM: var(--sp6x);

		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: calc(100% - var(--contPaddingLR) * 2);
		margin-top: var(--sp2x);
	}
`;
export default NavigationBuildingHeroStyle;
